import api from './axiosConfig';

export const getUpcomingInvoices = async (orgId: string) => {
  try {
    const response = await api({
      method: 'get',
      url: `/v2/organization/${orgId}/invoices/upcoming`,
    });

    return {
      error: false,
      data: response.data,
    };
  } catch (error) {
    console.error('Error fetching next invoice:', error);
    return {
      error: true,
      data: null,
    };
  }
};

export const getInvoices = async (orgId: string) => {
  try {
    const response = await api({
      method: 'get',
      url: `/v2/organization/${orgId}/invoices`,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const paySpecificInvoice = async (orgId: string, invoiceId: string) => {
  try {
    const response = await api({
      method: 'post',
      url: `/v2/organization/${orgId}/invoice/${invoiceId}/pay`,
    });

    return {
      error: false,
      data: response.data,
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
      data: null,
    };
  }
};
